import { startCase } from "lodash";
import OutsideClickHandler from "react-outside-click-handler";

export default function BonusSelect({
  options = [],
  value,
  onChange,
  setShow,
}) {
  return (
    <OutsideClickHandler onOutsideClick={() => setShow(false)}>
      <div
        className="v-menu__content theme--light menuable__content__active"
        style={{
          maxHeight: "304px",
          minWidth: "296px",
          top: "40%",
          left: "32px",
          transformOrigin: "left top",
          zIndex: "8",
          position: "fixed",
        }}
      >
        <div
          style={{ background: "white" }}
          role="listbox"
          className="v-list v-select-list v-sheet theme--light"
        >
          {options.map((item, index) => {
            const active = item?.title === value;

            return (
              <div
                key={index}
                role="option"
                tabIndex={0}
                aria-selected={active}
                className={`v-list-item v-list-item--link theme--light ${
                  active
                    ? "v-list-item--active primary--text v-list-item--highlighted"
                    : ""
                }`}
                onClick={() => {
                  onChange(item);
                  setShow(false);
                }}
              >
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    {startCase(item?.title)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>{" "}
    </OutsideClickHandler>
  );
}
